module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAxMyA4IiB3aWR0aD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTExLjYyODc3MzggMC01LjEyOTI1ODMgNS4yMTQxMzYyLTUuMTI5MjU4My01LjIxNDEzNjItMS4zNzAyNTcyIDEuMzkyOTMxOSA2LjQ5OTUxNTUgNi42MDcwNjgxIDYuNTAwNDg0NS02LjYwNzA2ODF6IiBmaWxsPSIjOTg5ODk4Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow.svg
// module id = 1456
// module chunks = 168707334958949